<template>
  <TheLayout>
    <loading v-if="loading"></loading>
    <div
      v-if="isCancelAll"
    >
      <div class="text-center">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon">
        <p class="mb-0">Đơn giao và đơn hàng sẽ <b>bị huỷ</b></p>
      </div>
      <div class="cancel-info">
        <span class="infor">
          <div v-if="!isCustomerPaid">
            <p>Phí trả ĐTGH và phí huỷ đơn sẽ tự động <b>trừ vào doanh thu.</b></p>
          </div>
          <div v-if="isCustomerPaid">
            <p style="word-break: break-word;">Đơn hàng đã được thanh toán, hãy chắc chắn hoàn tiền cho khách trước khi xác nhận huỷ đơn.<br>Phí trả ĐTGH và phí huỷ đơn sẽ tự động <b>trừ vào doanh thu.</b></p>
          </div>
        </span>
        <el-form>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="Vui lòng nhập chi phí phát sinh (nếu có):">
                <el-input style="width:48%" placeholder="0" v-model="returnFee" @input="($event) => inputMoney($event)"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <b-overlay
          :show="busy"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block loading-btn"
        >
          <el-button
            type="danger"
            :disabled="busy"
            @click="cancelAll"
          >
            Hủy đơn
          </el-button>
        </b-overlay>
        <el-button @click="$emit('closeModal')">Quay lại</el-button>
      </span>
    </div>
    
    <div
      v-if="isCancelAndReNew"
    >
      <div class="text-center" style="display: flex;flex-direction: column;align-items: center;">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon">
        <p class="mb-0" style="width:70%;word-break: break-word;">Đơn giao hàng hiện tại sẽ <b>bị huỷ</b>, vui lòng <b>tạo 1 đơn giao hàng mới</b> để tiếp tục bán.</p>
      </div>
      <div class="cancel-info">
        <span class="infor">
          <p>Thao tác huỷ giao có thể phát sinh chi phí. Phí trả ĐTGH và phí huỷ sẽ tự động <b>trừ vào doanh thu.</b></p>
        </span>
          <el-form>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="Vui lòng nhập chi phí phát sinh (nếu có):">
                  <el-input style="width:48%" placeholder="0" v-model="returnFee" @input="($event) => inputMoney($event)" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <b-overlay
          :show="busy"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block loading-btn"
        >
          <el-button
            type="danger"
            :disabled="busy"
            @click="cancelAndRenew"
          >
            Hủy đơn
          </el-button>
        </b-overlay>
        <el-button @click="$emit('closeModal')">Quay lại</el-button>
      </span>
    </div>
  </TheLayout>
</template>

<script>
import { OrdersService } from "@/services/nextshop/orders.service"
// import Swal from "sweetalert2"

export default {
    data() {
        return {
          loading: false,
          busy: false,
          returnFee: '',
        }
    },

    props: {
        isCancelAndReNew: {
            type: Boolean,
            default: false,
        },
        isCancelAll: {
            type: Boolean,
            default: false,
        },
        dataItem: {
          type: Object,
          default: () => {}
        },
        isCustomerPaid: {
          type: Boolean,
          default: false
        }
    },

    methods: {
      async cancelAll() {
        await this.update(true, false, true);
        this.$emit('updateStatus')
      },

      async cancelAndRenew() {
        await this.update(false, true);
        this.$emit('updateStatus')
      },

      async update(isCancelSO, isReNew, isAutoComplete = false) {
        this.loading = true; 
        try {
          const response = await OrdersService.updateStatusByMerchant(
            {
              orderId: this.dataItem.id,
              isCancelSO: isCancelSO,
              newStatus: "FAILED",
              returnFee:  this.checkNumReplaceComma(this.returnFee) * 1000 || 0,
            }
          )
          if (response.success) {
            this.loading = false;
            this.showSwalSuccess("Hủy đơn giao hàng và đơn hàng");
            if(isReNew) {
              this.$router.push({path: `/pos/pos-detail/${this.dataItem.furtherInstructions[0].params.soOrderId}`,query: {isReNew: true}})
            }
            this.$emit('closeModal');
          }
        } catch (error) {
          this.showSwalError("Hủy đơn giao hàng và đơn hàng", error);
          console.log(error);
        }
      },

      inputMoney(val) {
          this.returnFee = val
          this.returnFee = this.formatMoneyNotUnit(this.returnFee)
      },
    }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  flex-direction: row-reverse;
}
.loading-btn {
  margin-left: 10px;
}

.infor {
  display: flex;
  flex-direction: row;
  padding: 10px 16px 0px;
  background: #FEF5E1;
  border-radius: 4px;
  margin: 10px 0;
}
</style>